import { render, staticRenderFns } from "./locationTestB.vue?vue&type=template&id=5362dfd0&scoped=true&"
import script from "./locationTestB.vue?vue&type=script&lang=js&"
export * from "./locationTestB.vue?vue&type=script&lang=js&"
import style0 from "./locationTestB.vue?vue&type=style&index=0&id=5362dfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362dfd0",
  null
  
)

export default component.exports